import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { ConstantsService } from './constants.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DownloadRequest } from '../models/download-req-model';

@Injectable({
  providedIn: 'root'
})
export class DocumentDownloadService extends BaseService {

  constructor(public override http: HttpClient,
    public override constants: ConstantsService) {
    super(http, constants, constants.api_az_zip);
  }

  getDocuments(items: DownloadRequest): Observable<any> {
    return this.http.post(this.constants.api_az_zip + environment.api_code, items, { responseType: "blob" });
  }

}
